/* @flow */

import useBrowserDimensions from "helpers/use-browser-dimensions";

export const useBreakpoints = (styles: any) => {
  const { width: browserWidth } = useBrowserDimensions();

  const isCurrentBreakpoint = (breakpoint: string) =>
    (browserWidth < parseInt(styles[breakpoint], 10));

  const getNumberOfDisplayedItems = (
    breakpointColumnMapping: { [string]: number },
    defaultAmount: number
  ) => {
    const currentBreakpoint = Object.keys(breakpointColumnMapping).find(isCurrentBreakpoint);

    return !currentBreakpoint ? defaultAmount : breakpointColumnMapping[currentBreakpoint];
  };

  return {
    isCurrentBreakpoint,
    getNumberOfDisplayedItems,
  };
};
